import React from 'react'

export const Integrity = (props) => {
  return (
    <>
    <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 79.89 80.1"
    {...props}
  >
    <defs>
    </defs>
    <circle cx={35.05} cy={16.85} r={15.85} className="cls-2" />
    <path
      d="M45.34 42.15c-.32 2.83-.91 11.38 4.29 20.08 4.11 6.86 9.74 10.34 12.38 11.75 2.44-1.28 8.99-5.13 13.26-13.26C79.5 52.66 79 45.15 78.68 42.4c-1.52.18-5.25.43-9.35-1.52-4.35-2.07-6.56-5.39-7.33-6.69a19.642 19.642 0 0 1-6.32 5.56c-4.37 2.41-8.5 2.48-10.36 2.4Z"
      className="cls-2"
    />
    <path
      d="m53.43 52.88 6.82 5.18 9.09-9.6M15.91 44.29c-1.05.83-2.53 2.22-3.79 4.29a16.25 16.25 0 0 0-2.27 6.95v15.66h21.61"
      className="cls-2"
    />
    <path
      d="M69.84 68.14v7.99c-.11.34-.5 1.3-1.51 2.02-1.07.76-2.18.77-2.53.75H4.79c-1.06.42-2.26.17-3.03-.63-.7-.72-.94-1.79-.63-2.78V56.8c.07-2.46.57-8.11 4.42-13.64 5.93-8.52 15.22-10.2 17.05-10.49M47.08 32.17c1.76.32 4.48 1.03 7.38 2.74 1.61.95 2.93 2 3.98 3"
      className="cls-2"
    />
  </svg>
    </>
  )
}
